export default __webpack_public_path__ + "static/media/1875.052e9040.png";